import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faBank, faLocationDot, faEnvelope, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import "./MakePayment.css";

export default function MakePayment() {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedPlan = location.state?.plan || '';
  const price = location.state?.price || '';
  const duration = location.state?.duration || '';

  const handleChangePlan = () => {
    navigate('/curriculum-pricing');
  };

  return (
    <div className="payment-container">
      <div className="payment-header">
        <h1>Complete Your Payment</h1>
        <p>Please transfer the amount to our bank account and share the receipt</p>
      </div>

      <div className="payment-details">
        <div className="selected-plan">
          <h2>Selected Plan</h2>
          <div className="plan-details">
            <h3>
              {selectedPlan}
              <span className="change-plan-link" onClick={handleChangePlan}>
                (Change Plan)
              </span>
            </h3>
            <div className="price">
              <span className="rupee">₹</span>
              <span className="amount">{price}</span>
              <span className="period">/{duration}</span>
            </div>
          </div>
        </div>

        <div className="bank-info-card">
          <h2>Bank Details</h2>
          <div className="info-row">
            <FontAwesomeIcon icon={faBuilding} className="info-icon" />
            <div className="info-content">
              <span className="label">Account Name:</span>
              <span className="value">JUNIOR OLYMPIAD (MS. ARCHANA KUMARI)</span>
            </div>
          </div>
          <div className="info-row">
            <FontAwesomeIcon icon={faBuilding} className="info-icon" />
            <div className="info-content">
              <span className="label">Account Number:</span>
              <span className="value">31465006037</span>
            </div>
          </div>
          <div className="info-row">
            <FontAwesomeIcon icon={faBank} className="info-icon" />
            <div className="info-content">
              <span className="label">Bank Name:</span>
              <span className="value">STATE BANK OF INDIA</span>
            </div>
          </div>
          <div className="info-row">
            <FontAwesomeIcon icon={faLocationDot} className="info-icon" />
            <div className="info-content">
              <span className="label">Branch:</span>
              <span className="value">(012275)- BAGMUGALIYA (BHOPAL)</span>
            </div>
          </div>
          <div className="info-row">
            <FontAwesomeIcon icon={faLocationDot} className="info-icon" />
            <div className="info-content">
              <span className="label">Branch Address:</span>
              <span className="value">BAGMUGALIYA MAIN ROAD, NEAR AXIS BANK, ARVIND VIHAR, BAGMUGALIYA, BHOPAL</span>
            </div>
          </div>
          <div className="info-row">
            <FontAwesomeIcon icon={faBank} className="info-icon" />
            <div className="info-content">
              <span className="label">IFSC Code:</span>
              <span className="value">SBIN0012275</span>
            </div>
          </div>
        </div>

        <div className="payment-instructions">
          <h3>Instructions</h3>
            <h4>Note: Please do not transfer any amount without batch confirmation over phone and email.</h4>
          <ol>
            <li>Transfer the payment amount to the bank account mentioned above.</li>
            <li>Save the payment receipt.</li>
            <li>Email the receipt to <a href="mailto:support@juniorolympiad.com">support@juniorolympiad.com</a> from your registered email id.</li>
            <li>Include your name and contact details and course enrolled in the email.</li>
            <li>Our team will verify the payment and activate your subscription within next 24 hours.</li>
            <li>You will receive link to join the class and other information over your registered email address.</li>
          </ol>
        </div>

        <div className="payment-note">
          <p>Note: This is the only way of making payment. We do not entertain any other mode or way of payment. Your subscription will be activated within 24 hours of payment confirmation.</p>
        </div>
      </div>
    </div>
  );
}